import { httpCommon } from "../helper/http-common";

class LoginService {
  //Login Api
  login(InputData) {
    return httpCommon.post("Login/Login", InputData);
  }
  // Reset API service
  ResetPassword(InputData) {
    return httpCommon.post("Login/ResetPassword", InputData);
  }
}

const loginService = new LoginService();
export default loginService;
